module.exports = __webpack_public_path__ + "img/receipt1.b29d1fbd.png";